import { Modal } from '@components/Customized';

interface Props {
  open: boolean;
  onClose: () => void;
}

const RfqPaymentInProgressNotiModal = ({ open, onClose }: Props) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Modal.CloseButton onClose={onClose} />

      <Modal.Title>진행알림</Modal.Title>

      <Modal.ContentSection>
        <Modal.Text variant="h4" color="textPrimary" gutterBottoms={4}>
          파트너에게 결제 대금을 정산 중입니다.
          <br />
          상담 채팅을 종료할 수 없습니다.
        </Modal.Text>
      </Modal.ContentSection>

      <Modal.ButtonSection>
        <Modal.Button color="error" onClick={onClose}>
          확인
        </Modal.Button>
      </Modal.ButtonSection>
    </Modal>
  );
};

export default RfqPaymentInProgressNotiModal;
